import { computed } from '@ember/object';
import { readOnly, notEmpty } from '@ember/object/computed';
import RefundType from '@square/dashboard-data/models/squareup/common/refund-type';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { notEqual } from '@square/dashboard-utilities/macros';
import DateTime from '@square/dashboard-data/models/squareup/common/time/date-time';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
import ProcessingFeeAmounts from '@square/dashboard-data/models/squareup/beemo/api/v2/models/processing-fee-amounts';
export default ProtoBaseModel.extend({
  type: attr(RefundType),
  createdAt: attr(DateTime),
  processedAt: attr(DateTime),
  reason: attr(String),
  paymentToken: attr(String),
  refundedMoney: attr(MoneyProto),
  refundedGrossSalesMoney: attr(MoneyProto),
  refundedDiscountMoney: attr(MoneyProto),
  refundedNetSalesMoney: attr(MoneyProto),
  refundedTipMoney: attr(MoneyProto),
  refundedInclusiveTaxMoney: attr(MoneyProto),
  refundedAdditiveTaxMoney: attr(MoneyProto),
  refundedTaxMoney: attr(MoneyProto),
  refundedCreditMoney: attr(MoneyProto),
  refundedTotalCollectedMoney: attr(MoneyProto),
  refundedProcessingFeeMoney: attr(MoneyProto),
  refundedNetTotalMoney: attr(MoneyProto),
  refundedProcessingFeeAmounts: attr(ProcessingFeeAmounts),
  netRefundedProcessingFeeMoney: readOnly('refundedProcessingFeeMoney'),
  hasProcessingFees: notEqual('refundedProcessingFeeMoney.amount', 0),
  // True if there was a fee associated with the refund itself
  hasRefundProcessingFees: notEmpty('refundedProcessingFeeAmounts.squareProcessingFeeMoney'),
  refundedProcessingFeeAmountDetails: readOnly('refundedProcessingFeeAmounts'),
  positiveRefundedNetTotalMoney: computed('hasRefundProcessingFees', 'refundedMoney.negated', 'refundedNetTotalMoney.negated', 'refundedProcessingFeeAmounts.squareProcessingFeeMoney', function () {
    // If the refund has processing fee amount, we want the net total money refunded to account for the processing fee amount by deducting
    // it from the refundedMoney
    if (this.hasRefundProcessingFees) {
      // refundedMoney is expected to be negative. We negate it because it's the amount "Deducted", aka
      // the wording indicates the amount is deducted from the merchant
      const refundedMoney = this.refundedMoney?.negated;

      // If squareProcessingFeeMoney is positive, then the positiveRefundedNetTotalMoney will be
      // less than the refunded money. A positive squareProcessingFeeMoney represents that Square
      // was charged for the refund. If squareProcessingFeeMoney is negative, then positiveRefundedNetTotalMoney
      // will be greater than the refunded money. A negative squareProcessingFeeMoney
      // represents that Square gained money from the refund
      const squareProcessingFeeMoney = this.refundedProcessingFeeAmounts?.squareProcessingFeeMoney;
      return refundedMoney && squareProcessingFeeMoney ? refundedMoney.subtract(squareProcessingFeeMoney) : refundedMoney;
    }
    return this.refundedNetTotalMoney?.negated;
  }),
  receiptNumber: computed('paymentToken', function () {
    if (this.paymentToken) {
      return this.paymentToken.slice(0, 4);
    }
    return undefined;
  })
});